const breadCrumb = "Lançamento de Notas - Relatório de Notas";

const routes = [
  {
    path: "/emitir-relacao-de-alunos-sem-notas",
    name: "emitir-relacao-de-alunos-sem-notas",
    meta: {
      allowedPermissions: ["aluno_avaliacao_relacao_alunos_sem_notas"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/EmitirRelacaoDeAlunosSemNota/EmitirRelacaoDeAlunosSemNota.vue"
      ),
  },
];

export default routes;
